import { useQuery } from '@apollo/client/react';

import { GET_MAP } from '@atom/graph/map';
import { usePreferences } from '@atom/hooks/usePreferences';
import { EMPTY_MAP_DATA } from '@atom/map';
import { MapData, MapInput } from '@atom/types/map';

type UseTaskAssetMapDataArgs = {
  coordinates: string;
  zoomLevel: number;
  schemaIds: string[];
};

export const useTaskAssetMapData = ({
  coordinates,
  zoomLevel,
  schemaIds,
}: UseTaskAssetMapDataArgs): [MapData, boolean] => {
  const clusterDensity = usePreferences().map?.clusterDensity ?? 'default';

  const input: MapInput = {
    coordinates: coordinates ? (JSON.parse(coordinates) as number[][][]) : [],
    zoomLevel,
    clusterDensity,
    includeAssets: true,
    includeUsers: false,
    includeWorkOrders: false,
    schemaIds,
  };

  const { data, previousData, loading } = useQuery(GET_MAP, {
    variables: { input },
    skip: !coordinates,
    fetchPolicy: 'network-only',
  });

  return [data?.map ?? previousData?.map ?? EMPTY_MAP_DATA, loading];
};
